
import React, { useEffect, useState } from "react";
import ClientsCarousel from "./ClientsCarousel";

const Clients = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Mark as loaded after a brief delay to ensure DOM is ready
    const timeout = setTimeout(() => {
      setIsLoaded(true);
    }, 300); // Increased to ensure carousel is fully ready

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div id="clients" className="logos wow animate__animated animate__fadeIn">
      <div className="title-section" style={{ paddingTop: "5px", paddingLeft: "10px" }}>
        <img
          style={{
            mixBlendMode: "darken",
            width: "40px",
            display: "inline-flex",
            position: "absolute",
            marginTop: "-10px"
          }}
          src="/img/Comp1.gif"
          alt="Talk to them"
          loading="lazy"
          width="40"
          height="40"
        />
        <span style={{ paddingLeft: "40px" }}>Talk to them</span>
      </div>

      {/* React Carousel */}
      <div 
        id="clients-carousel" 
        className="clients-carousel-container"
        style={{ visibility: 'visible', opacity: 1 }}
      >
        <ClientsCarousel />
      </div>
    </div>
  );
};

export default Clients;
